import { useTranslation } from "react-i18next";

export const useGetRuleColumnDefs = (isDraft: boolean) =>{
	const {t}=useTranslation()
	return [
	{
		cellRenderer: "sortingCellRenderers",
		field: "action",
		headerName: "",
		flex: 1,
		sortable: false,
		cellRendererParams: {
			isDraft: isDraft,
		},
	},
	{
		cellRenderer: "nameCellRenderers",
		field: "name",
		headerName: t("pages.configuration.scheme.rulesColumnDetails.column1"),
		flex: 1,
		sortable: false,
		cellRendererParams: {
			isDraft: isDraft,
		},
		cellClass:"text-bold-underline"
	},
	{
		field: "description",
		headerName: t("pages.configuration.scheme.rulesColumnDetails.column2"),
		flex: 1,
		sortable: false,
	},
	{
		field: "className",
		flex: 1,
		sortable: false,
		headerName: t("pages.configuration.scheme.rulesColumnDetails.column3"),
	},
	{
		cellRenderer: "actionCellRenderers",
		field: "action",
		headerName: "",
		flex: 1,
		sortable: false,
		hide: !isDraft,
		cellClass: "align-right",
	},
]};
